'use client';

import 'react-day-picker/dist/style.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

import TimePicker from 'react-time-picker';

import { TextVariants, Colors } from '@lichtblick/theme';

import { FieldWithErrorContainer, TimePickerContainer } from './DatePicker.styles';

import { Text } from '../Text';

export const CustomTimePicker = ({
  error,
  fromTime,
  setFromTime,
  setToTime,
  toTime,
}: {
  error?: string | null;
  fromTime?: string | null;
  setFromTime?: (value: string | null) => void;
  setToTime?: (value: string | null) => void;
  toTime?: string | null;
}) => {
  return (
    <TimePickerContainer $hasError={!!error && error !== ''}>
      {setFromTime !== undefined && (
        <FieldWithErrorContainer>
          <TimePicker
            clearIcon={null}
            disableClock={true}
            onChange={(value) => setFromTime?.(value)}
            value={fromTime}
          />
          {error && error !== '' ? (
            <Text $variant={TextVariants.body.s} color={Colors.red[100]}>
              {error}
            </Text>
          ) : null}
        </FieldWithErrorContainer>
      )}
      {setToTime !== undefined && (
        <FieldWithErrorContainer>
          <TimePicker clearIcon={null} disableClock={true} onChange={(value) => setToTime?.(value)} value={toTime} />
          {error && error !== '' ? (
            <Text $variant={TextVariants.body.s} color={Colors.red[100]}>
              {error}
            </Text>
          ) : null}
        </FieldWithErrorContainer>
      )}
    </TimePickerContainer>
  );
};
